export enum EmployeeRoles {
  SUPERVISOR = "supervisor",
  REPRESENTATIVE = "representative"
}
